export default "__VITE_ASSET__BlyxeXAY__"